/** The sign-in screen (unit 23C's password; `core/people` rules 5 and 10). */
import { useState, type FormEvent } from "react";

import { reason } from "../api/query";
import { useSignIn } from "./session";
import styles from "./SignIn.module.css";

export function SignIn() {
  const signIn = useSignIn();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");

  function submit(event: FormEvent) {
    event.preventDefault();
    if (!name.trim() || !password) return;
    signIn.mutate({ name: name.trim(), password });
  }

  return (
    <main className={styles.page}>
      <form className={styles.card} onSubmit={submit}>
        <h1 className={styles.title}>Kindred</h1>
        <label className={styles.field}>
          <span>Name</span>
          <input
            autoComplete="username"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </label>
        <label className={styles.field}>
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {signIn.isError && (
          <p className={styles.error} role="alert">
            {reason(signIn.error)}
          </p>
        )}
        <button className={styles.submit} type="submit" disabled={signIn.isPending}>
          {signIn.isPending ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
